<template>
  <div class="TasksComponent">
    <p v-if="!selectedLastRevisionRow">{{lang.infotext_3}}</p>
    <div v-if="isData&&selectedLastRevisionRow">

      <p>{{lang.infotext_1}}:</p>

      <div v-for="item in tasks" :key="item.taskName">

        <div class="list-details">
          <b-list-group>
            <b-list-group-item v-if="!isSecondLevel">{{lang.label_Level1}}</b-list-group-item>
            <b-list-group-item v-if="isSecondLevel">{{lang.label_Level2}}</b-list-group-item>
            <b-list-group-item>{{lang.label_Name}}: {{item.taskName}}</b-list-group-item>
            <b-list-group-item>

              <span class="task-buttons">
                <b-button @click="checkIfLibrariesReady('approved')" size="sm" id="task_approve"
                  variant="success"><b-spinner v-show="isSpinner" small></b-spinner> {{lang.button_Approve}}</b-button>
                <b-button v-if="isSecondLevel" @click="eventTask('rejected')" size="sm" id="task_reject"
                  variant="danger">{{lang.button_Reject}}</b-button>
              </span>

            </b-list-group-item>
            <b-list-group-item v-show="item.comment.length!=0">
              <p>{{lang.label_Comment}}:</p>
              <p class="task-reason-text">{{item.comment}}</p>
            </b-list-group-item>
            <b-list-group-item v-show="item.reason.length!=0">
              <p>{{lang.label_Reason}}:</p>
              <p class="task-reason-text">{{item.reason}}</p>
            </b-list-group-item>

            <div v-for="comment in item.comments" :key="comment.id">
              <b-list-group-item v-show="comment.comment !=''">
                <p>{{longDateToShort(comment.creationDate)}} | {{comment.login}}</p>
                <p v-show="comment.type == 'reason'">{{lang.label_Reason}}:</p>
                <p v-show="comment.type == 'comment'">{{lang.label_Comment}}:</p>
                <p v-show="comment.type == 'transfer'">{{ lang.label_Transfer }}:</p>
                <p class="task-reason-text">{{comment.comment}}</p>
              </b-list-group-item>

            </div>


          </b-list-group>
        </div>

        <!-- <p>{{item.taskName}}</p>
              <span class="task-buttons">
              <b-button @click="eventTask('approved')" size="sm" id="task_approve" variant="success">{{lang.button_Approve}}</b-button>
              <b-button @click="eventTask('rejected')" size="sm" id="task_reject" variant="danger">{{lang.button_Reject}}</b-button>
              </span>
              <br><br> -->
        <!-- <span v-show="item.reason.length!=0">
                            
                <p>{{lang.label_Reason}}:</p>
                <p class="task-reason-text">{{item.reason}}</p>
              
              </span> -->


      </div>


    </div>


    <span v-if="!isData&&selectedLastRevisionRow">
      <p>{{lang.infotext_2}}</p>
    </span>



  </div>
</template>

<script>
  import LoaderComponent from "@/components/shared/LoaderComponent"
  import * as Tools from '@/Tools/Tools';
  import PartPropertiesType from '@/constants/PartPropertiesType'

  export default {
      name: "TasksComponent",
      props:{
        lang: Object,
        parent: String
      },
      components: {
        
        LoaderComponent
      },
      data () {
        return {
          name: "TasksComponent",
          tasks: [],
          //taskReason: "",
          isSpinner: false,
        }
      },
      computed: {
        isAssembly(){
          if (this.$store.getters.selectedRows[0] == undefined){
            return false;
          }
          return this.$store.getters.selectedRows[0].col___status.assembly == true;
        },
        revisionId(){
          let revisionId = "";
          if (this.parent == "details"){
            const tab = this.$store.getters.selectedRevisionRow
            let rev = 0;
            let revId = "";
            for (let i = 0, lei = tab.length; i < lei; i++){
              
              if (tab[i].revision > rev){
                rev = tab[i].revision;
                revId = tab[i].revisionId;
              }
              
            }


            revisionId = revId;
          }else{
            if (this.$store.getters.selectedRows.length != 0){
              revisionId = this.$store.getters.selectedRows[0].col___revisionId.revisionId;
                          
            }
          }
          
          return revisionId;

        },
        lastRevisionHistory(){
      
          let tab = this.$store.getters.revisionHistory;
          let obj = tab[0];
          for (let i = 0, lei = tab.length; i < lei; i++){
            
            if (tab[i].revision > obj.revision){
              obj = tab[i];
            }
          }
          
          return obj;
        },
        selectedLastRevisionRow(){
          if (this.parent == "table"){
            return true;
          }
          if (this.$store.getters.selectedRevisionRow.length == 0){
            return false;
          }
          return this.$store.getters.selectedRevisionRow[0].revisionId == this.lastRevisionHistory.id;
        },
        isData(){

          return this.tasks.length != 0

        },
        reloadedAfterActionComplex() {
          return this.$store.getters.reloadedAfterActionComplex;
        },
        isSecondLevel(){
          if (this.tasks.length > 0){
            return this.tasks[0].isSecondLevel;
          }
          return false;
        },
        saveStatus() {
          return this.$store.getters.saveStatus;
        }
      },
      created () {
        
        
        this.getTasks();


      },
      watch: {
        revisionId: function (newVal, oldVal) {
          
          
          this.getTasks();


        },
        reloadedAfterActionComplex: {
          handler: function (newValue) {

            for (let el in newValue) {

              if (newValue[el].name == this.name) {

                if (newValue[el].status == true) {

                  this.getTasks();

                  newValue[el].status = false;

                  this.$store.dispatch("reloadAfterActionComplex", newValue[el]);
                }
              }
            }
          },
          deep: true

        },
        
      },
      
  methods: {
    longDateToShort(date){
      return Tools.longDateToShort(date);
    },
    getTasks(){
      
      let vue = this;

      const obj = {
        revisionId: this.revisionId
      }

      this.$store.dispatch(this.$store.getters.sectionPrefix + "_getTasks", obj)
      .then((result) => {

        console.log(result)
        if (result.status == "OK"){

          vue.tasks = result.data
          for(let i = 0, lei = vue.tasks.length; i < lei; i++){

            if (vue.tasks[i].reason == null){
              vue.tasks[i].reason = "";
            }
            if (vue.tasks[i].comment == null){
              vue.tasks[i].comment = "";
            }
          }

          if (vue.tasks.length > 0){
            vue.$store.dispatch("setAuthorityToChange", true);
          }else{
            vue.$store.dispatch("setAuthorityToChange", false);
          }
        }


      })
    },
    checkIfLibrariesReady(status) {

      if (this.saveStatus === true) {
        this.$parent.$parent.$parent.$parent.$parent.$parent.$parent.$children[1].save();

      }

      let vue = this;
      this.isSpinner = true;

      let obj = {};
      if (this.$store.getters.sectionPrefix == "pm") {
        obj.partRevisionId = vue.revisionId;
      }
      if (this.$store.getters.sectionPrefix == "lm") {
        obj.libraryRevisionId = vue.revisionId;
      }
      this.$store.dispatch(this.$store.getters.sectionPrefix + "_checkIfLibrariesReady", obj)
        .then((result) => {

          console.log(result)

          vue.isSpinner = false;

          if (result.data.length > 0) {

            let funcCustom = function (_vue) {

            }

            obj = {

              text: "",
              type: "eventtaskValidation",
              buttons: 1,
              buttonName: "Close",
              size: "lg",
              lang: vue.lang.modal_EventTaskFormValidation,
              data: result.data,
              funcNo: "",
              funcOk: "",
              funcCustom: funcCustom
            };

            vue.$store.dispatch("showModalComponent", obj);

          } else {
            vue.eventTask("approved");
          }
        })

      
      
    },
    eventTask(status){

      let vue = this;

      

      
    
      if (status == "approved") {

        

        let funcYes = function(_vue){
          const obj = {
            revisionId: vue.revisionId,
            revision: 0
          }

          let method = "_getPart";
          if (vue.$store.getters.sectionPrefix == "lm"){
            method = "_getLibrary";
          }
          
          vue.$store.dispatch(vue.$store.getters.sectionPrefix + method, obj)
          .then((result) => {

            console.log(result)
            if (result.status == "OK"){
              
              
              let trig = true;
              let field = "";


              if(vue.isAssembly != true){
                let mechtrig = false;
                for (let i = 0, lei = result.data.length; i < lei; i++){
                  if (result.data[i].type == PartPropertiesType.TYPE && (result.data[i].value.display == "Mechanical" || result.data[i].value.display == "Software")){
                    mechtrig = true;
                  }

                }

                for (let i = 0, lei = result.data.length; i < lei; i++){
                  if (result.data[i].isRequiredOnRelease == true){
                    if (mechtrig == false){
                      
                        if (result.data[i].value == null){
                          field = result.data[i].name;
                          trig = false;
                          break;
                        }
                        if (result.data[i].value.display == ""){
                          field = result.data[i].name;
                          trig = false;
                          break;
                        }
                      
                    }else{
                      
                      if (result.data[i].type != PartPropertiesType.SYMBOL && result.data[i].type != PartPropertiesType.FOOTPRINT){
                        
                        if (result.data[i].value == null){
                          field = result.data[i].name;
                          trig = false;
                          break;
                        }
                        if (result.data[i].value.display == ""){
                          field = result.data[i].name;
                          trig = false;
                          break;
                        }
                        
                        
                      }
                      
                    }
                  
                  }
                }
              }
              
              if (trig == false){
                
                let obj = {
                  text: vue.lang.alert_error_approve1 + " " + field + " " + vue.lang.alert_error_approve2,
                  time: 15,
                  type: "danger"
                }

                vue.$store.dispatch("displayFooterAlert", obj);



              }else{
                
                const obj = {
                  revisionId: vue.revisionId,
                  action: status,
                  reason: vue.$store.getters.eventTaskForm.reason,
                  changeRevisionOfDependentParts: vue.$store.getters.eventTaskForm.changeRevisionOfDependentParts,
                  indicatedUserId: vue.$store.getters.eventTaskForm.indicatedUserId
                }
                
                vue.$store.dispatch(vue.$store.getters.sectionPrefix + "_setEventTask", obj)
                .then((result) => {

                  console.log(result)
                  if (result.status == "OK"){

                    vue.tasks = [];

                    vue.$store.dispatch("setAuthorityToChange", false);

                    const reloadObj = {
                      status: true,
                      name: "HistoryDetailsComponent"
                    }
                    
                    vue.$store.dispatch("reloadAfterActionComplex", reloadObj);

                    if(vue.parent != "details"){
                      
                      const reloadObj = {
                        status: true,
                        name: "DataTableFilteredOnApiComponent"
                      }
                      vue.$store.dispatch("reloadAfterActionComplex", reloadObj);
                    }else{
                      
                      const reloadObj = {
                        status: true,
                        name: "RevisionTableComponent"
                      }
                      vue.$store.dispatch("reloadAfterActionComplex", reloadObj);
                    }

                    let obj = {
                      text: vue.lang.alert_success_approve,
                      time: 10,
                      type: "success"
                    }

                    vue.$store.dispatch("displayFooterAlert", obj);

                    
                    

                  }else{
                    let obj = {
                      text: vue.lang.alert_error_approve + ": " + result.message,
                      time: 15,
                      type: "danger"
                    }

                    vue.$store.dispatch("displayFooterAlert", obj);


                  }

                })




              }
              

            }
            

          })
        }

        const obj = {
          
          text: "",
          type: "eventtaskform",
          buttons: 2,
          size: "md",
          lang: vue.lang.modal_EventTaskForm,
          data: {
            changeRevisionOfDependentPartsVisible: true,
            indicatedUserIdVisible: true,
            reasonVisible: true,
            isSecondLevel: vue.isSecondLevel
          },
          funcNo: "",
          funcYes: funcYes,
          
        };
        
        this.$store.dispatch("showModalComponent", obj);

        

      }else{

        let vue = this;

        let funcYes = function(_vue){

          

          const obj = {
            revisionId: vue.revisionId,
            action: status,
            reason: vue.$store.getters.eventTaskForm.reason,
            changeRevisionOfDependentParts: false,
            indicatedUserId: null
          }
          
          vue.$store.dispatch(vue.$store.getters.sectionPrefix + "_setEventTask", obj)
          .then((result) => {

            console.log(result)
            if (result.status == "OK"){
              vue.$store.dispatch("setAuthorityToChange", false);
              vue.tasks = [];
              
              let reloadObj = {
                status: true,
                name: "HistoryDetailsComponent"
              }
              
              vue.$store.dispatch("reloadAfterActionComplex", reloadObj);

              reloadObj = {
                status: true,
                name: "RevisionTableComponent"
              }
              vue.$store.dispatch("reloadAfterActionComplex", reloadObj);

            }else{



            }

          })
          
        }

        const obj = {
          
          text: "",
          type: "eventtaskform",
          buttons: 2,
          size: "md",
          lang: vue.lang.modal_Reason,
          data: {
            changeRevisionOfDependentPartsVisible: false,
            indicatedUserIdVisible: false,
            reasonVisible: true,
            isSecondLevel: vue.isSecondLevel
          },
          funcNo: "",
          funcYes: funcYes,
          
        };
        
        this.$store.dispatch("showModalComponent", obj);
      }

      

    },

  }


}
</script>
<style lang="scss">
.TasksComponent {
  .task-buttons{
    margin-left: 50px;
    
  }
  .task-reason-text{
    margin-left: 20px;
  }
  .list-group-item{
    margin-top: 5px;
  }
  
}
</style>



// WEBPACK FOOTER //
// src/components/shared/TasksComponent.vue